export default __webpack_public_path__ + "static/media/arul.2a3183b3.jpg";